export enum TimeIntervalType {
  None = 0,
  Day = 1,
  Month = 2,
  Year = 3,
  Week = 4
}
